import React from "react";

const LanguageList = (props: any) => {
  return <React.Fragment></React.Fragment>;
};

export default LanguageList;
